export interface Testimonial {
  id: string;
  name: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 't-1',
    name: '书友小糖',
    avatar: '',
    rating: 5,
    content: '真的太上头了！一口气追了五十章，剧情环环相扣，人物的心理描写太细腻了。沈墨辰这个角色塑造得太成功了，又爱又恨。作者文笔真的绝了！',
    date: '2024-07-20',
  },
  {
    id: 't-2',
    name: '夜色微凉',
    avatar: '',
    rating: 5,
    content: '闺蜜推荐我看的，一开始觉得这种题材可能很俗套，结果看了两章就停不下来了。每个人物都有血有肉，情节反转再反转，强烈推荐！',
    date: '2024-07-18',
  },
  {
    id: 't-3',
    name: '追文达人',
    avatar: '',
    rating: 4,
    content: '文笔流畅，情节紧凑，感情戏写得真的很到位。唯一的缺点就是更新太慢了，每天刷八百遍等更新！作者大大快更新！',
    date: '2024-07-15',
  },
  {
    id: 't-4',
    name: '书海泛舟',
    avatar: '',
    rating: 5,
    content: '在众多都市情感小说中，这部作品的深度和对人性的探讨是独树一帜的。不只是写情欲，更是在探讨人性、欲望和救赎。值得反复品读。',
    date: '2024-07-12',
  },
  {
    id: 't-5',
    name: '月下独酌',
    avatar: '',
    rating: 5,
    content: '从第一章追到现在，见证了作者文笔的飞跃进步。故事情节越来越精彩，人物关系越来越复杂，真的是一部不可多得的好作品！',
    date: '2024-07-08',
  },
  {
    id: 't-6',
    name: '春暖花开',
    avatar: '',
    rating: 5,
    content: '林婉儿的成长线写得太好了！从一个被命运摆布的棋子，到主动掌握自己人生的女王，这个蜕变过程让人热泪盈眶。每个女孩子都应该读一读。',
    date: '2024-07-05',
  },
];